import React from 'react';
import './config'; // Import the i18n config to initialize it

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
